"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomData_1 = require("./CustomData");
/**
 * @internal
 * create an empty WordConverter
 */
function createWordConverter() {
    return {
        nextUniqueId: 1,
        numBulletsConverted: 0,
        numNumberedConverted: 0,
        wordConverterArgs: null,
        customData: CustomData_1.createCustomData(),
    };
}
exports.createWordConverter = createWordConverter;
//# sourceMappingURL=wordConverter.js.map